import diff from 'object-diff';
import {
  GET_MANY,
  GET_MANY_REFERENCE,
  GET_LIST,
  GET_ONE,
  CREATE,
  UPDATE,
  UPDATE_MANY,
  DELETE,
  DELETE_MANY,
} from './redux/dataFetchActions';
import omit from 'lodash/omit';
import qs from 'qs';
import { handleTenancyApiError } from '@/features/tenancy';

export const feathersProvider = (options = {}) => {

  const mapRequest = (type, resource, params, meta, authProvider) => {
    const { host, subpath, customBackendUrl, getUrlFromAuth, customHeaders, trailingResourceSlash } = options;
    const { subResource, customAction, id, context, subId } = meta || {};
    //const secureEndpoint = authProvider('applySecureEndpoint');
    let url;
    if (customBackendUrl) {
      url = customBackendUrl(authProvider('getUser'))
    } else if (getUrlFromAuth) {
      url = authProvider('getBackendUrl');
    } else {
      url = host;
    }
    //let url = secureEndpoint ? `${host}/${secureEndpoint}` : host;
    url = subpath ? `${url}/${subpath}/${resource}` : `${url}/${resource}`;
    // TODO: need to allow for a a post path eg: /resource/sub/id or /models/addfile/1 to be provided
    // will need to update the dispatch actions to allow thi
    let data;
    let headers = {
      'Content-Type': 'application/json',
    };
    headers = authProvider('applyAuthentication', headers);
    if (customHeaders) headers = customHeaders(headers);
//    headers.Authorization = `Bearer ${authToken}`;
    let query = { };
    if (context && typeof context === 'object' && context !== null) {
      Object.keys(context).forEach((c) => {
        query[c] = context[c];
      })
      //query[context.field] = context.value;
    }
    const checkStatus = function checkStatus(res) {
      if (res.ok) {
        return res;
      }
      throw (res);
    };

    const parseError = function parseError(err) {
      if (!err.json) throw new Error("No server response");
      return err.json().then(errorMessage => {
        handleTenancyApiError(errorMessage);
        const error = Object.assign(
          new Error(errorMessage.message || 'Unknown server error'),
          errorMessage,
          { status: err.status },
        );
        throw error;
      });

    }
    // Form values are set to "" to get past a Formik error. But they then get marked as changed
    // when sending back to our Feathers backend (which uses null instead).
    // So if the value has only changed from null to "" let's ignore it
    const ignoreBlankComparator = function (a, b) {
      if ((a === null || a === '') && (b === null || b === '')) {
        return true;
      }
      return a === b;

    }
    switch (type) {
      case GET_LIST: {
        const { page, perPage } = params.pagination || {};
        // const { field, order } = params.sort || {};
        const q = [];
        if (perPage && page) {
          q.push(`$limit=${perPage}`);
          q.push(`$skip=${perPage * (page - 1)}`);
        }
        if (params.sort && params.sort.field) {
          q.push(`$orderBy=${params.sort.field}:${params.sort.order === 'desc' ? 'desc' : 'asc'}`);
        }
        /* if (order) {
          query.orderBy = `${[field === defaultIdKey ? idKey : field]}:${order === 'DESC' ? 'desc' : 'asc'}`;
        } */
        if (params.filter) {
          for (const filter in params.filter) {
            if (params.filter[filter]) {
              if (Array.isArray(params.filter[filter])) {
                params.filter[filter].forEach((inFilter) => {
                  q.push(`${filter}=${inFilter}`);
                });
              } else {
                q.push(`${filter}=${params.filter[filter]}`);
              }
            }
          }
        }

        if (params.fields) {
          q.push(`$fields=${params.fields.join(',')}`)
        }

        query = q.join('&');
        if (subResource) url = `${url}/${id ? `${id}/` : ''}/${subResource}`;
        if (customAction) url = `${url}/${id ? `${id}/` : ''}custom/${customAction}`;
        if (trailingResourceSlash) url = `${url}/`;
        url = `${url}?${query}`;
        return fetch(url, {
          headers,
        }).then(checkStatus).then((res) => res.json()).catch(parseError);
      }
      case GET_ONE:
        url = `${url}/${params.id}`;
        if (subResource) url = `${url}/${subResource}`;
        if (customAction) url = `${url}/custom/${customAction}`;

        let queryParams = omit(params, 'id');
        if (Object.keys(queryParams).length > 0) {
          /*Object.keys(qs).forEach((key) => {
            url += `/${key}/${encodeURIComponent(qs[key])}`;
          })*/
          url += `?${qs.stringify(queryParams)}`
        }
        return fetch(url, {
          headers,
        }).then(checkStatus).then((res) => res.json()).catch(parseError);
      case UPDATE:
        data = params.previousData ? diff.custom({
          equal: ignoreBlankComparator
        }, params.previousData, params.data) : params.data;
        url = `${url}/${id}`;
        if (subResource) url = params.id ? `${url}/${subResource}/${params.id}` : `${url}/${subResource}`;
        if (customAction) url = `${url}/custom/${customAction}`;

        return fetch(url, {
          headers,
          method: 'PATCH',
          body: JSON.stringify(data),
        }).then(checkStatus)
          .then((res) => res.json()).catch(parseError);
      case UPDATE_MANY:
        data = params.previousData ? diff(params.previousData, params.data) : params.data;
        return Promise.all(params.ids.map((id) => {
          let _url = `${url}/${id}`;
          if (subResource) _url = `${_url}/${subResource}`;
          if (customAction) _url = `${_url}/custom/${customAction}`;

          return fetch(_url, {
            headers,
            method: 'PATCH',
            body: JSON.stringify(data),
          }).then(checkStatus).then((res) => res.json()).catch(parseError);
        }));
      case CREATE:
        if (id && subResource) {
          url = `${url}/${id}/${subResource}`;
          if (subId) url = `${url}/${subId}`;
          if (customAction) url = `${url}/custom/${customAction}`;
        } else if (customAction) url = id ? `${url}/${id}/custom/${customAction}` : `${url}/custom/${customAction}`;
        else if (trailingResourceSlash) url = `${url}/`;

        return fetch(url, {
          headers,
          method: 'POST',
          body: JSON.stringify(params.data),
        }).then(checkStatus).then((res) => res.json()).catch(parseError);
      case DELETE:
        url = `${url}/${params.id}`;
        if (subResource) url = id ? `${url}/${subResource}/${id}` : `${url}/${subResource}`;
        if (customAction) url = `${url}/custom/${customAction}`;
        if (trailingResourceSlash) url = `${url}/`;
        return fetch(url, {
          headers,
          method: 'DELETE',
          body: JSON.stringify(params.data),
        }).then(checkStatus).catch(parseError);
      case DELETE_MANY:
        return Promise.all(params.ids.map((id) => {
          url = `${url}/${id}`;
          if (subResource) url = `${url}/${subResource}`;
          if (customAction) url = `${url}/custom/${customAction}`;
          if (trailingResourceSlash) url = `${url}/`;
          return fetch(url, {
            headers,
            method: 'DELETE',
          }).then(checkStatus).catch(parseError);
        }));
      default:
        return Promise.reject(new Error(`Unsupported Imminently action ${type}`));
    }
  };

  const mapResponse = (response, type, resource, params, meta) => {
    const getId = (item) => {
      if (options.idOptions && options.idOptions.all) return options.idOptions.all(item);
      else if (options.idOptions && options.idOptions[resource]) return options.idOptions[resource](item);
      else return item.id;
    }
    switch (type) {
      case GET_ONE:
      case UPDATE:
        return { data: { ...response, id: getId(response) } };
      case CREATE:
        return { data: { ...params.data, ...response, id:  getId(response)} };
      case DELETE:
        return { data: null };
      case UPDATE_MANY:
        return { data: response.map((record) => getId(response)) };
      case DELETE_MANY:
        return { data: null };
      case GET_MANY_REFERENCE:
      case GET_MANY:
      case GET_LIST:
        return {
          total: response.total,
          data: response.data.map((item) => {
            const _item = item;
            _item.id = getId(item);
            return _item;
          }),
        };
      default:
        return response;
    }
  };

  return (type, resource, params, meta, authProvider) => mapRequest(type, resource, params, meta, authProvider)
    .then((response) => mapResponse(response, type, resource, params, meta));
};
